import {Injectable} from '@angular/core';

export interface SocialAuthProvider {
  id: string;
  provider: {
    clientId: string;
  };
}

export interface SocialAuthServiceConfig {
  autoLogin: boolean;
  providers: SocialAuthProvider[];
  onError?: (err: any) => void;
}

@Injectable({providedIn: 'root'})
export class SocialAuthProviderService {
  socialAuthServiceConfig: SocialAuthServiceConfig = {
    autoLogin: false,
    providers: [{
      id: 'MICROSOFT', 
      provider: {clientId: '3d5522d7-bd89-4a91-b7fe-4b19e650b37f'}
    }],
    onError: (err: any) => {
      console.error('Social auth error:', err);
    }
  };

  loadSocialLoginIds = (): Promise<SocialAuthServiceConfig> => 
    Promise.resolve(this.socialAuthServiceConfig);
}